<template>
  <div class="company-joint-setting" v-loading="loading">
    <div class="title">
      <div class="close" @click="goToJoint">
        <span class="pointer">
          系统对接 /
          <span style="color: #606266">钉钉</span>
        </span>
      </div>
    </div>
    <div class="setting">
      <el-form
        ref="jointForm"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="left"
      >
        <div class="company-info">
          <div class="titleInfo">企业信息</div>
          <el-form-item label="CorpId" prop="corpId">
            <el-input v-model="form.corpId"></el-input>
          </el-form-item>
        </div>
        <div class="app-info">
          <div class="titleInfo">应用信息</div>
          <el-form-item label="AgentId" prop="agentid">
            <el-input v-model="form.agentid"></el-input>
            <span class="link">
              <el-link
                href="https://developers.dingtalk.com/document/tutorial/develop-h5-micro-applications?spm=a2q3p.21071111.0.0.4e3265eeWtgoGX"
                target="_blank"
                type="primary"
                :underline="false"
              >
                如何创建应用？
              </el-link>
            </span>
          </el-form-item>
          <el-form-item label="AppKey" prop="appkey">
            <el-input v-model="form.appkey"></el-input>
          </el-form-item>
          <el-form-item label="AppSecret" prop="appsecret">
            <el-input v-model="form.appsecret"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="other-setting">
        <div class="titleInfo">系统对接</div>
        <el-divider></el-divider>
        <div class="operation">
          <div class="operation-wrap">
            <div class="introduce">
              <div class="item">组织架构同步</div>
              <div style="font-size: 14px; color:#9e9e9e">
                开启并操作同步后，企业成员将与钉钉保持一致
              </div>
            </div>
            <div class="action">
              <el-switch :value="syncDing" @input="openSync"></el-switch>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
      </div>
      <base-button type="primary" @click="submitForm('jointForm')" style="margin: 40px 1px">
        保存
      </base-button>
    </div>
    <confirm-dialog
      ref="confirmDialog"
      title="组织架构同步"
      tip="开启后，组织架构将抹去差异人员，并与钉钉保持完全一致。是否开启？"
      @confirm="syncDing = true"
      @cancel="syncDing = false"
    ></confirm-dialog>
  </div>
</template>
<script>
import BaseButton from "@/components/UIComponents/Button"
import { getCurCompany, updateDingConfig } from "@/api/userCenter/company"
import ConfirmDialog from "@/components/ConfirmDialog.vue"
export default {
  name: "company-joint-setting",
  components: { BaseButton, ConfirmDialog },
  data() {
    return {
      loading: false,
      form: {
        corpId: "",
        agentid: "",
        appkey: "",
        appsecret: ""
      },
      rules: {
        corpId: [{ required: true, message: "请输入CorpId", trigger: "blur" }],
        agentid: [{ required: true, message: "请输入AgentId", trigger: "blur" }],
        appkey: [{ required: true, message: "请输入AppKey", trigger: "blur" }],
        appsecret: [{ required: true, message: "请输入AppSecret", trigger: "blur" }]
      },
      currentCompany: {
        id: "",
        dingConfig: {},
        dingEnable: false
      },
      syncDing: false
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      getCurCompany().then(currentCompany => {
        this.currentCompany = currentCompany
        if (this.currentCompany.dingConfig) {
          this.form = this.currentCompany.dingConfig
        }
        this.syncDing = this.currentCompany.syncDing
        this.loading = false
      })
    },
    goToJoint() {
      this.$router.push({ name: "company-system-joint" })
    },
    submitForm(ref) {
      this.$refs[ref].validate(valid => {
        if (valid) {
          this.currentCompany.dingConfig = this.form
          this.currentCompany.syncDing = this.syncDing
          updateDingConfig(this.currentCompany).then(() => this.$message.success("编辑成功"))
        } else {
          return false
        }
      })
    },
    openSync(open) {
      if (open) {
        this.$refs.confirmDialog.open()
      } else {
        this.syncDing = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.company-joint-setting {
  .title {
    font-size: $font-size-title-first;
    padding: 0 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
    .close {
      display: flex;
      align-items: center;
      color: #84878c;
    }
  }
  .setting {
    margin: 30px 105px 30px 105px;
    .titleInfo {
      font-weight: bold;
      margin-bottom: 20px;
    }
    .el-form-item {
      width: 550px;
      margin-left: 20px;
      .el-link {
        vertical-align: unset;
      }
      .el-input {
        width: 320px;
      }
    }
    .app-info {
      margin-top: 30px;
      .link {
        margin-left: 10px;
      }
    }
    .other-setting {
      .operation {
        .operation-wrap {
          padding: 0 100px 0 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          .introduce {
            flex: 1;
            .item {
              font-size: 14px;
              margin-bottom: 5px;
              font-weight: bold;
            }
          }
          .action {
            .setting {
              margin-left: 6px;
              font-size: 14px;
              color: #1989fa;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
